/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import type {
  ArchiveSoftwareBody,
  CreateSoftwareBody,
  SoftwareSummary,
  UpdateSoftwareBody,
} from "../models/index";
import {
  ArchiveSoftwareBodyFromJSON,
  ArchiveSoftwareBodyToJSON,
  CreateSoftwareBodyFromJSON,
  CreateSoftwareBodyToJSON,
  SoftwareSummaryFromJSON,
  SoftwareSummaryToJSON,
  UpdateSoftwareBodyFromJSON,
  UpdateSoftwareBodyToJSON,
} from "../models/index";

export interface ArchiveSoftwareRequest {
  archiveSoftwareBody: ArchiveSoftwareBody;
}

export interface CreateSoftwareRequest {
  createSoftwareBody: CreateSoftwareBody;
}

export interface GetSoftwareRequest {
  softwareId: string;
}

export interface UpdateSoftwareRequest {
  updateSoftwareBody: UpdateSoftwareBody;
}

/**
 *
 */
export class PeopleSoftwareApi extends runtime.BaseAPI {
  /**
   */
  async archiveSoftwareRaw(
    requestParameters: ArchiveSoftwareRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["archiveSoftwareBody"] == null) {
      throw new runtime.RequiredError(
        "archiveSoftwareBody",
        'Required parameter "archiveSoftwareBody" was null or undefined when calling archiveSoftware().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/people/software/archive`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: ArchiveSoftwareBodyToJSON(
          requestParameters["archiveSoftwareBody"],
        ),
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async archiveSoftware(
    requestParameters: ArchiveSoftwareRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.archiveSoftwareRaw(requestParameters, initOverrides);
  }

  /**
   */
  async createSoftwareRaw(
    requestParameters: CreateSoftwareRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["createSoftwareBody"] == null) {
      throw new runtime.RequiredError(
        "createSoftwareBody",
        'Required parameter "createSoftwareBody" was null or undefined when calling createSoftware().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/people/software/create`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: CreateSoftwareBodyToJSON(requestParameters["createSoftwareBody"]),
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async createSoftware(
    requestParameters: CreateSoftwareRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.createSoftwareRaw(requestParameters, initOverrides);
  }

  /**
   */
  async getSoftwareRaw(
    requestParameters: GetSoftwareRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<SoftwareSummary>> {
    if (requestParameters["softwareId"] == null) {
      throw new runtime.RequiredError(
        "softwareId",
        'Required parameter "softwareId" was null or undefined when calling getSoftware().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["softwareId"] != null) {
      queryParameters["softwareId"] = requestParameters["softwareId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/people/software/get`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      SoftwareSummaryFromJSON(jsonValue),
    );
  }

  /**
   */
  async getSoftware(
    requestParameters: GetSoftwareRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<SoftwareSummary> {
    const response = await this.getSoftwareRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async listSoftwareRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Array<SoftwareSummary>>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/people/software/list`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(SoftwareSummaryFromJSON),
    );
  }

  /**
   */
  async listSoftware(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Array<SoftwareSummary>> {
    const response = await this.listSoftwareRaw(initOverrides);
    return await response.value();
  }

  /**
   */
  async updateSoftwareRaw(
    requestParameters: UpdateSoftwareRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["updateSoftwareBody"] == null) {
      throw new runtime.RequiredError(
        "updateSoftwareBody",
        'Required parameter "updateSoftwareBody" was null or undefined when calling updateSoftware().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/people/software/update`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: UpdateSoftwareBodyToJSON(requestParameters["updateSoftwareBody"]),
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async updateSoftware(
    requestParameters: UpdateSoftwareRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.updateSoftwareRaw(requestParameters, initOverrides);
  }
}
